var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from 'axios';
import { API_STAGES, API_URLS } from './api';
const query = `mutation Checkout(
    $items: [ItemInput!],
    $paymentToken: String,
    $customer: CustomerInput,
    $shipping: AddressInput,
    $billing: AddressInput,
    $coupons: [CouponInput!],
    $customFields: TransactionCustomFields,
    $paymentInstrument: PaymentInstrumentInput
  ) {
    checkout(
      items: $items,
      coupons: $coupons,
      customer: $customer,
      shipping: $shipping,
      billing: $billing,
      paymentToken: $paymentToken,
      paymentInstrument: $paymentInstrument,
      customFields: $customFields
    ) {
      transaction {
        id,
        amount,
        status,
        result,
        paymentInstrument {
          method,
          paymentCardId
        }
      },
      customer {
        email,
        id
      }
    }
  }`;
export const createTransaction = (params) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const { sandbox } = params;
        const result = yield axios.post(sandbox ? API_URLS.local : API_URLS.prod, {
            query,
            variables: JSON.stringify(params),
        }, {
            headers: {
                'Content-Type': 'application/json',
                'X-Stage': sandbox ? API_STAGES.local : API_STAGES.prod,
            },
        });
        if (result.data === undefined) {
            throw Error(result);
        }
        return result.data;
    }
    catch (ex) {
        if (ex.response) {
            console.log(`Error: ${JSON.stringify(ex.response.data)}`);
        }
        throw ex;
    }
});
